import { Button, CircularProgress, Dialog, DialogActions, DialogContent, Fab, Grid, TextField } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';


export default class DialogSignUp extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'sm'}

                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid style={{ textAlign: 'center' }} container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField

                                    className="loginTextField inputFocus"
                                    id="with-placeholder"
                                    label={this.dictionary.login.societyName}
                                    name='numeSocietate'
                                    margin="normal"
                                    value={this.props.numeSocietate}
                                    onChange={this.props.handleChange}
                                // InputProps={{
                                //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                // }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="loginTextField inputFocus"
                                    id="with-placeholder"
                                    label={this.dictionary.login.cui}
                                    name='cui'
                                    margin="normal"
                                    value={this.props.cui}
                                    onChange={this.props.handleChange}
                                // InputProps={{
                                //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                // }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="loginTextField inputFocus"
                                    id="with-placeholder"
                                    label={this.dictionary.login.userName}
                                    name='numeUser'
                                    margin="normal"
                                    value={this.props.numeUser}
                                    onChange={this.props.handleChange}
                                // InputProps={{
                                //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                // }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="loginTextField inputFocus"
                                    id="with-placeholder"
                                    label={this.dictionary.login.user}
                                    name="email"
                                    margin="normal"
                                    value={this.props.email}
                                    onChange={this.props.handleChange}
                                // InputProps={{
                                //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                // }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="loginTextField inputFocus"
                                    id="with-placeholder"
                                    label={this.dictionary.login.password}
                                    name='parola'
                                    margin="normal"
                                    value={this.props.parola}
                                    onChange={this.props.handleChange}
                                // InputProps={{
                                //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                // }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="loginTextField inputFocus"
                                    id="with-placeholder"
                                    label={this.dictionary.login.repeatPassword}
                                    name='repetaParola'
                                    margin="normal"
                                    value={this.props.repetaParola}
                                    onChange={this.props.handleChange}
                                // InputProps={{
                                //     startAdornment: <InputAdornment position="start"><i className='material-icons pm-input-icon'>email</i></InputAdornment>,
                                // }}
                                />
                            </Grid>

                            <span className='pm-warning-validate'>{this.state.labRez}</span>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="loginButton" >
                                {this.props.loading &&
                                    <CircularProgress
                                        style={{
                                            width: 60,
                                            height: 60,
                                            color: '#25e048',
                                        }}
                                        value={20}

                                    />
                                }

                                {!this.props.loading &&

                                    <Button variant="outlined" className='pm-login-button' color="primary" onClick={this.props.checkAndSignUp}>
                                        {this.dictionary.login.signUp}
                                    </Button>
                                }

                                {/* <span className='pm-login-signup-text-container'><span className='pm-appbar-list-text'>{this.dictionary.login.or}</span> <span onClick={() => { this.props.history.push('/signup') }} className='pm-appbar-signup-text'>{this.dictionary.login.signUp}</span></span> */}


                            </Grid>

                        </Grid>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}